import { render, staticRenderFns } from "./PortalHeader.vue?vue&type=template&id=01423066&"
import script from "./PortalHeader.vue?vue&type=script&lang=js&"
export * from "./PortalHeader.vue?vue&type=script&lang=js&"
import style0 from "./PortalHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports